import { useCarePlusPrice } from "../useCarePlusPrice";
import { Translate } from "../../ChoosePlanCarePlus/planContent";
import OptionRadio from "./OptionRadio";

// borderless row: radio, title with the price on the same line, two-line
// description with the delivery caveat in bold.
interface Props {
  t: Translate;
  price: number;
  isSelected: boolean;
  onSelect: () => void;
}

const PrescriptionOnlyRow = ({ t, price, isSelected, onSelect }: Props) => {
  const { formatPrice } = useCarePlusPrice();
  return (
  <div
    id="wl3_plan_prescription_only"
    data-testid="care-plus-prescription-only-option"
    onClick={onSelect}
    className="flex w-full cursor-pointer items-start gap-[10px] px-[10px]"
  >
    <OptionRadio selected={isSelected} />
    <div className="flex min-w-0 flex-1 flex-col gap-[2px]">
      <div className="flex items-start justify-between gap-[8px]">
        <span className="text-[14px] font-medium leading-[21px] text-[#08080a]">{t("tier_prescription_only", "Prescription only")}</span>
        {price > 0 && <span className="shrink-0 text-[13px] font-medium leading-[20px] text-[#08080a]">{formatPrice(price)}</span>}
      </div>
      <p className="text-[12px] leading-[18px] text-[#8a9099]">
        {t("desc_prescription_only", "Treatment fee only, no plan,")}
        <br />
        <span className="font-bold">{t("desc_prescription_only_delivery", "delivery can take up to 14 days")}</span>
      </p>
    </div>
  </div>
  );
};

export default PrescriptionOnlyRow;
